import {createGlobalStyle} from 'styled-components'

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: Inter;
    font-style: normal;
    src: local("Inter"), local("Inter-Regular"), url("https://unpkg.com/inter-ui@3.5.0/Inter%20(web)/Inter-Regular.woff") format("woff");
  }

  @font-face {
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    src: local("Inter Medium"), local("Inter-Medium"), url("https://unpkg.com/inter-ui@3.5.0/Inter%20(web)/Inter-Medium.woff") format("woff");
  }
`
export default GlobalStyle